import { Node, mergeAttributes } from '@tiptap/core';

export const VideoNode = Node.create({
  name: 'video',
  inline: false,
  group: 'block',
  draggable: true,
  selectable: true,
  atom: true,

  addAttributes() {
    return {
      src: { default: '' },
      poster: { default: null },
    };
  },

  parseHTML() {
    return [{ tag: 'video[src]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'video',
      mergeAttributes(HTMLAttributes, {
        controls: 'true',
        preload: 'metadata',
        class: 'rounded-lg max-w-full',
      }),
    ];
  },
});
